import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import '../../components/public/Public.css';
import './Payment.css';

export default function PaymentFailed() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get('ref');

  return (
    <div className="pub-page">
      <Navbar />
      <div className="pay-result">
        <div className="pay-result-card">
          <div className="pay-result-icon failed">✕</div>
          <h1>Payment Unsuccessful</h1>
          <p>
            We couldn't process your payment. This may be due to insufficient funds, a cancelled prompt,
            or a timeout. No charge has been made — please try again.
          </p>
          {ref && <div className="pay-result-ref">Ref: {ref}</div>}
          <div className="pay-result-actions">
            <button className="pub-btn pub-btn-ghost" style={{background:'var(--gray-100)', color:'var(--text-secondary)', border:'1.5px solid var(--border)'}} onClick={() => navigate('/')}>
              Back to Events
            </button>
            {ref && (
              <button className="pub-btn pub-btn-primary" onClick={() => navigate(`/payment/${ref}`)}>
                Try Again
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
